module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "externalReturnSheetEntry"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": _vm.title,
      "large": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.missing_fields.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Please answer the following mandatory question(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.missing_fields), function(error) {
    return _c('li', [_vm._v("\n                        " + _vm._s(error.label) + "\n                    ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.incorrect_entry.length > 0) ? _c('div', {
    staticStyle: {
      "margin": "10px",
      "padding": "5px",
      "color": "red",
      "border": "1px solid red"
    },
    attrs: {
      "id": "error"
    }
  }, [_c('b', [_vm._v("Error in Quantity")]), _vm._v(" "), _c('ul', _vm._l((_vm.incorrect_entry), function(error) {
    return _c('li', [_vm._v("\n                        " + _vm._s(error.message) + "\n                    ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "sheetEntryForm"
    }
  }, [_c('alert', {
    attrs: {
      "show": _vm.showError,
      "type": "danger"
    },
    on: {
      "update:show": function($event) {
        _vm.showError = $event
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.errorString))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Activity:")])]), _vm._v(" "), (_vm.isStockEntry) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.activityList[_vm.entryActivity]['label']))])]) : _vm._e(), _vm._v(" "), (_vm.isAddEntry && !_vm.isStockEntry) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryActivity),
      expression: "entryActivity"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.entryActivity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.filteredActivityList), function(activity, activityId) {
    return (activity['auto'] == 'false') ? _c('option', {
      domProps: {
        "value": activityId
      }
    }, [_vm._v(_vm._s(activity['label']))]) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isChangeEntry && !_vm.isStockEntry) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.filteredActivityList[_vm.entryActivity]['label']) + " ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Activity Date:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    ref: "activityDateToPicker",
    staticClass: "input-group date",
    attrs: {
      "name": "activityDateToPicker",
      "required": "true"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryActivityDate),
      expression: "entryActivityDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY",
      "id": "entryActivityDate"
    },
    domProps: {
      "value": (_vm.entryActivityDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryActivityDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Quantity:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryQty),
      expression: "entryQty"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.entryQty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryQty = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Total Number:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryTotal),
      expression: "entryTotal"
    }],
    attrs: {
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.entryTotal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryTotal = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isLicenceRequired) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Receiving licence:")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Name of")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Supplier/Recipient:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entrySupplier),
      expression: "entrySupplier"
    }],
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.entrySupplier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entrySupplier = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Keeper, Import or Export")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Licence number:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryLicence),
      expression: "entryLicence"
    }],
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.entryLicence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryLicence = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Comments:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entryComment),
      expression: "entryComment"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "name": "entry_comments"
    },
    domProps: {
      "value": (_vm.entryComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.entryComment = $event.target.value
      }
    }
  })])])])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPayable),
      expression: "!isPayable"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update()
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPayable),
      expression: "isPayable"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.check_and_pay()
      }
    }
  }, [_vm._v("Pay")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "150px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f268bd88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/returns/enter_return_sheet_entry.vue
// module id = 1064
// module chunks = 0